import React, { ReactElement } from 'react';
import { getDisplayName } from '../../utils';
import { Device } from '../../generated/graphql';

export interface DeviceNameProps {
  options: readonly Device[];
  selected: readonly Device[];
}

export function DeviceName({ selected }: Readonly<DeviceNameProps>): ReactElement<DeviceNameProps> {
  return <>{getDisplayName(selected[0]) ?? ''}</>;
}
